const DEFAULT_AVATAR_SVG =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="32" fill="#e2e8f0"/><circle cx="32" cy="26" r="10" fill="#94a3b8"/><path d="M12 54c4-10 12-14 20-14s16 4 20 14" fill="#94a3b8"/></svg>',
  );

export function defaultAvatarUrl() {
  return DEFAULT_AVATAR_SVG;
}

export function resolveAvatarUrl(path) {
  if (!path) {
    return DEFAULT_AVATAR_SVG;
  }

  // If it's already a full URL (CDN, S3, external)
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // Support both VUE_APP_* and VITE_*
  const base =
    process.env.VUE_APP_BASE_URL ||
    process.env.VITE_API_BASE_URL ||
    process.env.VITE_BASE_URL ||
    window.location.origin + "/";

  // Ensure trailing slash consistency
  const cleanBase = base.endsWith("/") ? base.slice(0, -1) : base;

  // Ensure path starts with one slash
  const cleanPath = path.startsWith("/") ? path : "/" + path;

  return cleanBase + cleanPath;
}
